// Bump the version suffix to re-show the tutorial after meaningful changes.
export const EVENTS_TUTORIAL_SEEN_KEY = "events_tutorial_seen_v1";

// Steps are resolved by the `data-tour` attribute on each section. Steps whose
// target is missing on a given page are skipped automatically by SpotlightTour,
// so the player and team events pages can share this single list. Copy is
// localized via i18next — pass the page's `t` function.
export const buildEventsTutorialSteps = (t) => [
  {
    selector: '[data-tour="matches"]',
    title: t("eventsTutorial.matchesTitle"),
    body: t("eventsTutorial.matchesBody"),
  },
  {
    selector: '[data-tour="parameters"]',
    title: t("eventsTutorial.parametersTitle"),
    body: t("eventsTutorial.parametersBody"),
  },
  {
    selector: '[data-tour="sequence-context"]',
    title: t("eventsTutorial.sequenceContextTitle"),
    body: t("eventsTutorial.sequenceContextBody"),
  },
  {
    selector: '[data-tour="flanks"]',
    title: t("eventsTutorial.flanksTitle"),
    body: t("eventsTutorial.flanksBody"),
  },
  {
    selector: '[data-tour="body-part"]',
    title: t("eventsTutorial.bodyPartTitle"),
    body: t("eventsTutorial.bodyPartBody"),
  },
  {
    selector: '[data-tour="time-range"]',
    title: t("eventsTutorial.timeRangeTitle"),
    body: t("eventsTutorial.timeRangeBody"),
  },
  {
    selector: '[data-tour="pitch"]',
    title: t("eventsTutorial.pitchTitle"),
    body: t("eventsTutorial.pitchBody"),
  },
  {
    selector: '[data-tour="watch"]',
    title: t("eventsTutorial.watchTitle"),
    body: t("eventsTutorial.watchBody"),
  },
];
